import loadable from "@loadable/component";


export default loadable(() => import(/* webpackChunkName: "paymentSuccessPage.m" */ "./Loadable"));
